import React from 'react'
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import PropTypes from 'prop-types'

import datePickerStyles from '../styles/components/datepicker.module.scss';

const Datepicker = ({ label, defaultValue, value, minDate, maxDate, altFormat, onChange, enableTime, disabled, datePickerKey }) => {
    const disabledStyle = disabled ? datePickerStyles.__disabled : '';
    return (
        <>
            <h4 style={{textAlign:'left'}}>{label}</h4>
            <Flatpickr
                key={datePickerKey ? datePickerKey : 'datePicker'}
                className={[datePickerStyles.__picker, disabledStyle].join(' ')}
                defaultValue={defaultValue || moment().toISOString()}
                value={value}
                options={{
                    minDate: minDate || null,
                    maxDate: maxDate || null,
                    enableTime: enableTime,
                    altInput: true,
                    altFormat: altFormat || 'F j, Y h:i K',
                    dateFormat: 'Y-m-d H:i'
                }}
                disabled={disabled}
                onChange={(date, dateString, instance) => {if(dateString) onChange(dateString)}}
            />
        </>
    )
}

Datepicker.propTypes = {
    datePickerKey: PropTypes.string,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    value: PropTypes.string.isRequired,
    enableTime: PropTypes.bool.isRequired,
    minDate: PropTypes.string,
    altFormat: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default Datepicker

